import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Connects to data-controller="resumin--bridge--back-button"
// このコンポーネントは、HotwireNativeで実装したアプリのみ動作します。
// Bridgeコンポーネントからアプリに対して、イベントを通知し、
// アプリのヘッダーにある戻るボタンの表示・非表示を制御します。
export default class extends BridgeComponent {
  static component = "back-button";
  static values = {
    // 接続時（初期のタイミング）で表示するかどうか
    // デフォルトはこのコンポーネントが呼び出される場合、アプリのヘッダーのバックボタンは非表示にする
    showOnConnectValue: { type: Boolean, default: false },
  };

  connect() {
    super.connect();

    let event = this.showOnConnectValue ? "show" : "hide";
    this.send(event, {}, () => {});
  }

  disconnect() {
    // 初期表示時と反対のイベントを通知する。
    let event = !this.showOnConnectValue ? "show" : "hide";
    this.send(event, {}, () => {});

    super.disconnect();
  }

  show(e) {
    this.send("show", {}, () => {});
  }

  hide(e) {
    this.send("hide", {}, () => {});
  }
}
